/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-debugger */
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack5';
import { useEffect } from 'react';
import { Form, FormikProvider, useFormik } from 'formik';
// material
import { LoadingButton } from '@material-ui/lab';
import { Card, Grid, Stack, TextField, Autocomplete, Box, Checkbox } from '@material-ui/core';
import CaseConvertor from '../../common-components/CaseConvertor';
import { useDispatch, useSelector } from '../../../redux/store';
import { createHeader, updateHeader, resetCreateHeaderStatus, resetHeaderError } from '../../../redux/slices/header';
import { getProjectListByClient, resetProjectListByClient } from '../../../redux/slices/client';
import { getCategoryListByProject, resetCategoryListByProject } from '../../../redux/slices/filecategory';

// ----------------------------------------------------------------------

CreateHeaderForm.propTypes = {
  editId: PropTypes.number,
  setVisibleComponent: PropTypes.func,
  currentHeader: PropTypes.object
};

export default function CreateHeaderForm({ editId, currentHeader = {}, setVisibleComponent }) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { error, createHeaderStatus, isLoading } = useSelector((state) => state.header);
  const { clientList, projectListByClient } = useSelector((state) => state.client);
  const { categoryListByProject } = useSelector((state) => state.filecategory);

  useEffect(() => {
    if (error || createHeaderStatus) {
      enqueueSnackbar(
        (createHeaderStatus && (!editId ? 'New Header Created Successfully' : 'Header Updated Successfully')) ||
          (error && error),
        { variant: error ? 'error' : 'success' }
      );
      dispatch(resetHeaderError());
    }
    if (createHeaderStatus) {
      setVisibleComponent('List');
      formik.resetForm();
      dispatch(resetCreateHeaderStatus());
    }
  }, [error, createHeaderStatus]);

  const NewHeaderSchema = Yup.object().shape({
    headerName: Yup.string().required('Header name is required'),
    client: Yup.array()
      .of(
        Yup.object().shape({
          value: Yup.mixed(),
          label: Yup.mixed()
        })
      )
      .min(1, 'client is required'),
    project: Yup.array()
      .of(
        Yup.object().shape({
          value: Yup.mixed(),
          label: Yup.mixed()
        })
      )
      .min(1, 'project is required'),
    file_type: Yup.array()
      .of(
        Yup.object().shape({
          value: Yup.mixed,
          label: Yup.mixed
        })
      )
      .min(1, 'file type is required')
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      headerName: editId ? currentHeader.header_name : '',
      client: editId ? currentHeader.clients : [],
      project: editId ? currentHeader.projects : [],
      category: editId ? currentHeader.file_type : []
    },
    validationSchema: NewHeaderSchema,
    onSubmit: async (values, { setSubmitting, setErrors }) => {
      try {
        const headerData = {
          header_name: CaseConvertor(values.headerName),
          clients: values.client.map((a) => a.id),
          projects: values.project.map((a) => a.id),
          file_type: values.category.map((a) => a.id)
        };
        dispatch(!editId ? createHeader(headerData) : updateHeader(headerData, editId));
        setSubmitting(false);
      } catch (error) {
        console.error(error);
        setErrors(error);
      }
    }
  });

  const { errors, values, touched, handleSubmit, setFieldValue, getFieldProps } = formik;

  return (
    <FormikProvider value={formik}>
      <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Card sx={{ p: 3, overflow: 'visible' }}>
              <Stack spacing={3}>
                <TextField
                  fullWidth
                  label="Header Name"
                  required
                  {...getFieldProps('headerName')}
                  error={Boolean(touched.headerName && errors.headerName)}
                  helperText={touched.headerName && errors.headerName}
                />
                {/* <Autocomplete
                  fullWidth
                  multiple
                  name="Select Client"
                  value={values?.client ? values?.client : null}
                  options={CLIENT_OPTION}
                  onChange={(e, value) => setFieldValue('client', value)}
                  getOptionLabel={(option) => (option ? option?.client_name : '')}
                  renderInput={(params) => (
                    <TextField
                      error={Boolean(touched.client && errors.client)}
                      helperText={touched.client && errors.client}
                      required
                      {...params}
                      label="Select Client"
                      margin="none"
                    />
                  )}
                /> */}

                <Autocomplete
                  fullWidth
                  multiple
                  name="Select Client"
                  value={values?.client ? values?.client : []}
                  options={clientList}
                  onChange={(e, value) => {
                    setFieldValue('project', []);
                    setFieldValue('fileCategory', []);
                    setFieldValue('client', value);
                    dispatch(resetCategoryListByProject());
                    if (value) {
                      const arrayid = value.map((item) => item.id);
                      dispatch(getProjectListByClient(arrayid));
                    } else {
                      dispatch(resetProjectListByClient());
                    }
                  }}
                  disableCloseOnSelect
                  getOptionLabel={(option) => (option ? option?.client_name : '')}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox checked={selected} />
                      {option.client_name}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      error={Boolean(touched.client && errors.client)}
                      helperText={touched.client && errors.client}
                      required
                      {...params}
                      label="Select Client"
                      margin="none"
                    />
                  )}
                />
                {/* <Autocomplete
                  fullWidth
                  multiple
                  name="Select Project"
                  value={values?.project ? values?.project : null}
                  options={PROJECT_OPTION}
                  onChange={(e, value) => setFieldValue('project', value)}
                  getOptionLabel={(option) => (option ? option?.project_name : '')}
                  renderInput={(params) => (
                    <TextField
                      error={Boolean(touched.project && errors.project)}
                      helperText={touched.project && errors.project}
                      required
                      {...params}
                      label="Select Project"
                      margin="none"
                    />
                  )}
                /> */}

                <Autocomplete
                  fullWidth
                  multiple
                  name="Select Project"
                  value={values?.project ? values?.project : []}
                  options={projectListByClient}
                  onChange={(e, value) => {
                    setFieldValue('fileCategory', []);
                    setFieldValue('project', value);
                    if (value) {
                      const arrayid = value.map((item) => item.id);
                      dispatch(getCategoryListByProject(arrayid));
                    } else {
                      dispatch(resetCategoryListByProject());
                    }
                  }}
                  disableCloseOnSelect
                  getOptionLabel={(option) => (option ? option?.project_name : '')}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox checked={selected} />
                      {option.project_name}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      error={Boolean(touched.project && errors.project)}
                      helperText={touched.project && errors.project}
                      required={!editId}
                      {...params}
                      label="Select Project"
                      margin="none"
                    />
                  )}
                />

                <Autocomplete
                  fullWidth
                  multiple
                  name="Select File Type"
                  value={values?.category ? values?.category : []}
                  options={categoryListByProject}
                  onChange={(e, value) => setFieldValue('category', value)}
                  disableCloseOnSelect
                  getOptionLabel={(option) => (option ? option?.category_name : '')}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox checked={selected} />
                      {option.category_name}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      error={Boolean(touched.project && errors.project)}
                      helperText={touched.project && errors.project}
                      required={!editId}
                      {...params}
                      label="Select File Type"
                      margin="none"
                    />
                  )}
                />
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                  <LoadingButton type="submit" variant="contained" loading={isLoading}>
                    {!editId ? 'Save' : 'Save Changes'}
                  </LoadingButton>
                </Box>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Form>
    </FormikProvider>
  );
}
